import * as moment from 'moment';
  
  
export class ApplicationException {
  message?: string;
  stackTrace?: string;
}

export class Attachment {
  idAttachment: number;
  idAttachmentType: AttachmentTypeEnum;
  fileName?: string;
  contentType?: string;
  fileUrl?: string;
}

export enum AttachmentTypeEnum {
  CONTRACT = 1,
  DOCUMENTATION = 2,
  OTHER = 3,
  EMAIL = 4,
}

export class AuthApplicationCommand {
  clientId?: string;
  secret?: string;
  authApplicationCode?: string;
  ipAddress?: string;
}

export class AuthGenerateResetPasswordCodeCommand {
  username?: string;
  clientApplication: ClientApplication;
}

export class AuthRefreshTokenCommand {
  authApplicationCode?: string;
  username?: string;
  refreshToken?: string;
  ipAddress?: string;
}

export class AuthResetPasswordCommand {
  username?: string;
  resetPasswordCode?: string;
  password?: string;
  confirmPassword?: string;
}

export class AuthRole {
  idAuthRole: number;
  code?: string;
  name?: string;
}

export class AuthRoleListQueryResponse {
  items?: AuthRole[];
}

export class AuthTokenByIdAuthJwtTokenCommand {
  idAuthJwtToken: string;
  ipAddress?: string;
}

export class AuthTokenCommand {
  authApplicationCode?: string;
  username?: string;
  password?: string;
  ipAddress?: string;
}

export class AuthTokenHotacDailyRemindCommand {
  idHotel: number;
  username?: string;
  authApplicationCode?: string;
  dateUtc: moment.Moment;
  ipAddress?: string;
}

export class AuthTokenHotacReservationDetailRemindCommand {
  idHotel: number;
  authApplicationCode?: string;
  username?: string;
  idServiceTransportHubToHotel: number;
  ipAddress?: string;
}

export class AuthVerifyResetPasswordCodeCommand {
  username?: string;
  resetPasswordCode?: string;
}

export class AuthenticationToken {
  idAuthJwtToken: string;
  idUser: number;
  username?: string;
  accessToken?: string;
  expiresIn: number;
  refreshToken?: string;
  refreshTokenExpiresIn: number;
}

export class BillingInformationSaveCommand {
  idBillingInformation?: number;
  idCustomer?: number;
  businessName?: string;
  idCountry?: number;
  address?: string;
  zipCode?: string;
  vatNumber?: string;
  sdi?: string;
  pec?: string;
}

export class ChannelManagerCreateCommand {
  name?: string;
  notes?: string;
}

export class ChannelManagerItem {
  idChannelManager: number;
  name?: string;
  notes?: string;
}

export class ChannelManagerListForDropDownResponse {
  items?: ChannelManagerSummary[];
}

export class ChannelManagerListResponse {
  items?: ChannelManagerItem[];
}

export class ChannelManagerProcessingState {
  id: ChannelManagerProcessingStateEnum;
  name?: string;
}

export enum ChannelManagerProcessingStateEnum {
  FIRST_CONTACT = 1,
  PROCESSING = 2,
  SOLICIT = 3,
  CONNECTING = 4,
  CONNECTED = 5,
  NO = 6,
}

export class ChannelManagerSummary {
  idChannelManager: number;
  name?: string;
}

export class ChannelManagerUpdateCommand {
  idChannelManager: number;
  name?: string;
  notes?: string;
}

export enum ClientApplication {
  Sales = 0,
  Repro = 1,
}

export class CommercialManagement {
  idCommercialManagement: number;
  idHotelDealProcessingState: HotelDealProcessingStateEnum;
  idOwner?: number;
  owner?: string;
  name?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  note?: string;
  representativeName?: string;
  representativeEmail?: string;
  hotelsCount?: number;
  roomsCount?: number;
}

export class CommercialManagementCreateCommand {
  name?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  note?: string;
}

export class CommercialManagementListForDropDownResponse {
  items?: CommercialManagementSummary[];
}

export class CommercialManagementListQuery {

}

export class CommercialManagementListResponse {
  items?: CommercialManagement[];
  hotelCounts?: any;
}

export class CommercialManagementSummary {
  idCommercialManagement: number;
  name?: string;
}

export class CommercialManagementUpdateCommand {
  idCommercialManagement: number;
  idHotelDealProcessingState: HotelDealProcessingStateEnum;
  idOwner?: number;
  name?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  province?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  note?: string;
}

export class ContractAttachmentListQueryResponse {
  items?: HotelContractAttachment[];
}

export class ContractServiceListResponse {
  items?: HotelContractService[];
}

export class Country {
  idCountry: number;
  code?: string;
  name?: string;
  search?: string;
}

export class CountryListQueryResponse {
  items?: Country[];
}

export class Customer {
  idCustomer: number;
  idBillingInformation?: number;
  idLanguageCulture: number;
  idOwner?: number;
  name?: string;
  businessName?: string;
  idCountry?: number;
  address?: string;
  zipCode?: string;
  vatNumber?: string;
  sdi?: string;
  pec?: string;
  ownerName?: string;
  idDealProcessingState: HotelDealProcessingStateEnum;
  idContractState: HotelContractStateEnum;
  idCustomerContractType: CustomerContractTypeEnum;
}

export class CustomerAirlineCompany {
  idCustomerAirlineCompany: number;
  name?: string;
  idPassengerRegistrationTypeDefault: PassengerRegistrationTypeEnum;
  passengerRegistrationTypeDefaultName?: string;
  idVoucherSnackManagementTypeDefault: VoucherSnackManagementTypeEnum;
  voucherSnackManagementTypeDefaultName?: string;
  passengerGroupListUploadTypes?: PassengerGroupListUploadType[];
  needsTransport: boolean;
  customer: Customer;
}

export class CustomerAirlineCompanyListQueryResponse {
  items?: CustomerAirlineCompany[];
}

export class CustomerAirlineCompanySaveCommand {
  idCustomerAirlineCompany?: number;
  name?: string;
  idLanguageCulture: number;
  idVoucherSnackManagementTypeDefault?: VoucherSnackManagementTypeEnum;
  idPassengerRegistrationTypeDefault?: PassengerRegistrationTypeEnum;
  needsTransport?: boolean;
  idsPassengerGroupListUploadType?: PassengerGroupListUploadTypeEnum[];
}

export class CustomerContract {
  idCustomerContract: number;
  idCustomer: number;
  idCustomerContractType: CustomerContractTypeEnum;
  idContractState: CustomerContractStateEnum;
  idCustomerContractPaymentMode: CustomerContractPaymentModeEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
  signedOnDate?: moment.Moment;
  plafond?: number;
}

export class CustomerContractAttachment {
  idCustomerContractAttachment: number;
  idAttachment: number;
  idCustomerContract: number;
  attachment: Attachment;
}

export class CustomerContractAttachmentDeleteCommand {
  idAttachment: number;
}

export class CustomerContractAttachmentListQueryResponse {
  items?: CustomerContractAttachment[];
}

export class CustomerContractCloneCommand {
  idContractSource: number;
  idCustomer: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
  signedOnDate?: moment.Moment;
  idCustomerContractPaymentMode: CustomerContractPaymentModeEnum;
  plafond?: number;
}

export class CustomerContractHotelRateCloneCommand {
  idCustomerContractHotelRateSource: number;
  idsTransportHub?: number[];
}

export class CustomerContractHotelRateFlat {
  idCustomerContractHotelRate: number;
  idCustomerContract: number;
  singleRate?: number;
  doubleRate?: number;
  tripleRate?: number;
  lunchRate?: number;
  dinnerRate?: number;
  boxRate?: number;
  customerContractHotelRateInTransportHub?: CustomerContractHotelRateInTransportHub[];
}

export class CustomerContractHotelRateIdTransportHubListQueryResponse {
  items?: number[];
}

export class CustomerContractHotelRateInTransportHub {
  idCustomerContractHotelRateInTransportHub: number;
  idTransportHub: number;
  iataCode?: string;
  name?: string;
  iataAndName?: string;
}

export class CustomerContractHotelRateListQueryResponse {
  items?: CustomerContractHotelRateFlat[];
}

export class CustomerContractHotelRatePercentage {
  idCustomerContractHotelRate: number;
  idCustomerContract: number;
  ratePercentage?: number;
}

export class CustomerContractHotelSaveFlatRateCommand {
  idCustomerContract: number;
  idCustomerContractType: CustomerContractTypeEnum;
  idsTransportHub?: number[];
  idCustomerContractHotelRate?: number;
  singleRate?: number;
  doubleRate?: number;
  tripleRate?: number;
  lunchRate?: number;
  dinnerRate?: number;
  boxRate?: number;
}

export class CustomerContractHotelSavePercentageRateCommand {
  idCustomerContract: number;
  idCustomerContractType: CustomerContractTypeEnum;
  idCustomerContractHotelRate?: number;
  ratePercentage?: number;
}

export class CustomerContractListResponse {
  items?: CustomerContract[];
}

export class CustomerContractPaymentMode {
  id: CustomerContractPaymentModeEnum;
  name?: string;
}

export enum CustomerContractPaymentModeEnum {
  VIEW_INVOICE = 1,
  BANK_TRANSFER_30_DAYS = 2,
  BANK_TRANSFER_60_DAYS = 3,
  CORPORATE_CARD = 4,
  WARRANTY = 5,
}

export class CustomerContractSaveCommand {
  idCustomerAirlineCompany: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
  idCustomerContract?: number;
  signedOnDate?: moment.Moment;
  idCustomerContractPaymentMode: CustomerContractPaymentModeEnum;
  plafond?: number;
}

export enum CustomerContractStateEnum {
  ACTIVE = 1,
  INACTIVE = 2,
  EXPIRED = 3,
}

export class CustomerContractTransportRateListQueryResponse {
  items?: SupplierTransportContractPlanRate[];
}

export class CustomerContractTransportRateSaveCommand {
  idCustomerContract: number;
  idsTransportHub?: number[];
  idSupplierTransportContractPlanRate?: number;
}

export class CustomerContractType {
  id: CustomerContractTypeEnum;
  name?: string;
}

export enum CustomerContractTypeEnum {
  PERCENTAGE_RATE = 1,
  FLAT_RATE = 2,
}

export enum EntityEnum {
  SUPPLIER_TRANSPORT = 1,
  SUPPLIER_HOTEL = 2,
  SUPPLIER_FOOD_SERVICE = 3,
  CUSTOMER_AIRLINE_COMPANY = 4,
}

export class GeolocationPosition {
  latitude: number;
  longitude: number;
}

export class HotacTestSendCommand {
  idHotel: number;
  idHotelContactType: HotelIropContactTypeEnum;
}

export class Hotel {
  idHotel: number;
  hasCommercialManagement: boolean;
  idCommercialManagement?: number;
  idHotelChain?: number;
  idChannelManager?: number;
  idLanguageCulture?: number;
  idChannelManagerProcessingState: ChannelManagerProcessingStateEnum;
  uniqueCode: string;
  name?: string;
  address?: string;
  ianaName?: string;
  rooms?: number;
  roomsPMR?: number;
  hotelCategory?: number;
  sigleRooms?: number;
  doubleRooms?: number;
  tripleRooms?: number;
  quadrupleRooms?: number;
  hasRestaurant: boolean;
  idReprotectionAvailabilityState: ReprotectionAvailabilityStateEnum;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  latitude?: number;
  longitude?: number;
  isChannelManagerActivated: boolean;
  externalIdChannelManager?: string;
  emailAccountChannelManager?: string;
  channelManagerProcessingStateUpdatedAt?: moment.Moment;
  notes?: string;
  idsTransportHub?: number[];
  commercialManagement: CommercialManagement;
  hotelChain: HotelChain;
  channelManager: ChannelManagerItem;
}

export class HotelAiCallConfigurationItem {
  idHotelAiCallConfiguration?: number;
  idHotel: number;
  idHotelAiCallMode: HotelAiCallModeEnum;
}

export class HotelAiCallConfigurationSaveCommand {
  idHotelAiCallConfiguration?: number;
  idHotel: number;
  idHotelAiCallMode: HotelAiCallModeEnum;
}

export class HotelAiCallMode {
  id: HotelAiCallModeEnum;
  name?: string;
}

export enum HotelAiCallModeEnum {
  HUMAN = 1,
  IVR = 2,
  MIXED = 3,
}

export class HotelBookingContact {
  idHotelBookingContact?: number;
  email?: string;
  notificationsPrefix?: string;
  notificationsPhone?: string;
  contactCenterPrefix?: string;
  contactCenterPhone?: string;
}

export class HotelBookingContactSaveCommand {
  idHotel: number;
  idHotelBookingContact?: number;
  email?: string;
  notificationsPrefix?: string;
  notificationsPhone?: string;
  contactCenterPrefix?: string;
  contactCenterPhone?: string;
}

export class HotelChain {
  idHotelChain: number;
  name?: string;
  description?: string;
}

export class HotelChainCreateCommand {
  name?: string;
  description?: string;
}

export class HotelChainListForDropDownResponse {
  items?: HotelChain[];
}

export class HotelChainListItem {
  idHotelChain: number;
  name?: string;
  description?: string;
  hotelsCount: number;
}

export class HotelChainListResponse {
  items?: HotelChainListItem[];
}

export class HotelChainUpdateCommand {
  idHotelChain: number;
  name?: string;
  description?: string;
}

export class HotelCompleteListItem {
  idHotel: number;
  hotel?: string;
  transportHubs?: string;
  indirizzo?: string;
  gestioneCommerciale?: string;
  contattoGestioneCommerciale?: string;
  catena?: string;
  categoria?: string;
  camere?: number;
  camerePMR?: number;
  ristorante?: string;
  camereSingole?: number;
  camereDoppie?: number;
  camereTriple?: number;
  camereQuadruple?: number;
  email?: string;
  telefono?: string;
  coordinate?: string;
  languageCulture?: string;
  channelManager?: string;
  externalIdChannelManager?: string;
  isChannelManagerActivated: boolean;
  note?: string;
  referenteOperativo?: string;
  contattoOperativo?: string;
  owner?: string;
  status?: string;
  inizioContratto?: string;
  fineContratto?: string;
  firmato?: string;
  statoContratto?: string;
  referenteContratto?: string;
  emailReferenteContratto?: string;
  rinnovoTacito?: string;
  modalitàPagamento?: string;
  formatoAccordo?: string;
  cityTax?: number;
  cityTaxNote?: string;
  allegati?: string;
  accordo?: string;
  tariffe?: string;
  standardDayUseSingola?: number;
  standardDayUseDus?: number;
  standardDayUseDoppia?: number;
  standardDayUseTripla?: number;
  standardDayUseQuadrupla?: number;
  standardRoomOnlySingola?: number;
  standardRoomOnlyDus?: number;
  standardRoomOnlyDoppia?: number;
  standardRoomOnlyTripla?: number;
  standardRoomOnlyQuadrupla?: number;
  standardBedAndBrekfastSingola?: number;
  standardBedAndBrekfastDus?: number;
  standardBedAndBrekfastDoppia?: number;
  standardBedAndBrekfastTripla?: number;
  standardBedAndBrekfastQuadrupla?: number;
  superiorDayUseSingola?: number;
  superiorDayUseDus?: number;
  superiorDayUseDoppia?: number;
  superiorDayUseTripla?: number;
  superiorDayUseQuadrupla?: number;
  superiorRoomOnlySingola?: number;
  superiorRoomOnlyDus?: number;
  superiorRoomOnlyDoppia?: number;
  superiorRoomOnlyTripla?: number;
  superiorRoomOnlyQuadrupla?: number;
  superiorBedAndBrekfastSingola?: number;
  superiorBedAndBrekfastDus?: number;
  superiorBedAndBrekfastDoppia?: number;
  superiorBedAndBrekfastTripla?: number;
  superiorBedAndBrekfastQuadrupla?: number;
  pranzo?: number;
  cena?: number;
  box?: number;
  noteRistorante?: string;
  tariffaPet?: number;
  tipoTariffaPet?: string;
  earlyCheckin?: number;
  tipoEarlyCheckin?: string;
  lateCheckout?: number;
  tipoLateCheckout?: string;
  reminderGiornaliero?: boolean;
  emailReminderGiornaliero?: string;
  telefonoReminderGiornaliero?: string;
  cellulareReminderGiornaliero?: string;
  alertAperturaServizio?: boolean;
  emailAlertAperturaServizio?: string;
  telefonoAlertAperturaServizio?: string;
  cellulareAlertAperturaServizio?: string;
  emailPrenotazioni?: string;
  telefonoPrenotazioni?: string;
  cellularePrenotazioni?: string;
}

export class HotelContractAgreementFormat {
  id: HotelContractAgreementFormatEnum;
  name?: string;
}

export enum HotelContractAgreementFormatEnum {
  EMAIL = 1,
  LTS = 2,
  HOTEL = 3,
  GROUP = 4,
}

export class HotelContractAttachment {
  idContractAttachment: number;
  idAttachment: number;
  idContract: number;
  attachment: Attachment;
}

export class HotelContractAttachmentDeleteCommand {
  idAttachment: number;
}

export class HotelContractCloneCommand {
  idHotelContractSource: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export class HotelContractCreateCommand {
  idHotel: number;
  idHotelContractAgreementFormat: HotelContractAgreementFormatEnum;
  idHotelContractPaymentMode: HotelContractPaymentModeEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
  signedOnDate?: moment.Moment;
  referentName?: string;
  referentEmail?: string;
  tacitRenewal: boolean;
  cityTax?: number;
  cityTaxNotes?: string;
}

export class HotelContractItem {
  idContract: number;
  idHotel: number;
  idContractType: HotelContractTypeEnum;
  idContractState: HotelContractStateEnum;
  idContractAgreementFormat: HotelContractAgreementFormatEnum;
  idContractPaymentMode: HotelContractPaymentModeEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
  signedOnDate?: moment.Moment;
  tacitlyRenewedAt?: moment.Moment;
  referentName?: string;
  referentEmail?: string;
  tacitRenewal: boolean;
  cityTax?: number;
  cityTaxNotes?: string;
}

export class HotelContractListResponse {
  items?: HotelContractItem[];
}

export class HotelContractPaymentMode {
  id: HotelContractPaymentModeEnum;
  name?: string;
}

export enum HotelContractPaymentModeEnum {
  PAY_PER_LINK = 1,
  VIRTUAL_CARD = 2,
  CHARGE_UPON_CONFIRMATION = 3,
  CHARGE_UPON_CHECK_IN = 4,
  CHARGE_UPON_CHECK_OUT = 5,
  ON_INVOICE_VIEW = 6,
  FIVE_DAYS_FROM_INVOICE_EMISSION = 7,
  FIFTEEN_DAYS_FROM_INVOICE_EMISSION = 8,
  THIRTY_DAYS_FROM_INVOICE_EMISSION = 9,
  SIXTY_DAYS_FROM_INVOICE_EMISSION = 10,
}

export class HotelContractPerType {
  id: HotelContractPerTypeEnum;
  name?: string;
}

export enum HotelContractPerTypeEnum {
  PER_PERSON = 1,
  PER_ROOM = 2,
}

export class HotelContractPlanRateReadQueryResponse {
  idHotelContract: number;
  idHotelContractPlanRate: number;
  idHotelContractType: HotelContractTypeEnum;
  bestAvailableRateSalePercentage?: number;
  hotelRoomGroups?: HotelRoomGroup[];
}

export class HotelContractPlanRateSaveCommand {
  idContract: number;
  idHotel: number;
  idContractType: HotelContractTypeEnum;
  hotelRoomGroups?: HotelRoomGroup[];
}

export class HotelContractService {
  idHotelContractService?: number;
  idHotelContract: number;
  idHotelContractServiceType: HotelContractServiceTypeEnum;
  idHotelContractStayType: HotelContractStayTypeEnum;
  idHotelContractPerType: HotelContractPerTypeEnum;
  hotelContractServiceRestaurant: HotelContractServiceRestaurant;
  hotelContractServicePet: HotelContractServicePet;
  hotelContractServiceLateCheckOut: HotelContractServiceLateCheckOut;
  hotelContractServiceEarlyCheckIn: HotelContractServiceEarlyCheckIn;
}

export class HotelContractServiceEarlyCheckIn {
  idHotelContractServiceEarlyCheckIn?: number;
  idHotelContractService?: number;
  rate?: number;
}

export class HotelContractServiceLateCheckOut {
  idHotelContractServiceLateCheckOut?: number;
  idHotelContractService?: number;
  rate?: number;
}

export class HotelContractServicePet {
  idHotelContractServicePet?: number;
  idHotelContractService?: number;
  rate?: number;
}

export class HotelContractServiceRestaurant {
  idHotelContractServiceRestaurant?: number;
  idHotelContractService?: number;
  lunchRate?: number;
  dinnerRate?: number;
  lunchboxRate?: number;
  notes?: string;
}

export class HotelContractServiceSaveCommand {
  idHotelContract: number;
  items?: HotelContractService[];
}

export class HotelContractServiceType {
  id: HotelContractServiceTypeEnum;
  name?: string;
}

export enum HotelContractServiceTypeEnum {
  RESTAURANT = 1,
  PET = 2,
  EARLY_CHECKIN = 3,
  LATE_CHECKOUT = 4,
}

export class HotelContractState {
  id: HotelContractStateEnum;
  name?: string;
}

export enum HotelContractStateEnum {
  ACTIVE = 1,
  INACTIVE = 2,
  EXPIRED = 3,
}

export class HotelContractStayType {
  id: HotelContractStayTypeEnum;
  name?: string;
}

export enum HotelContractStayTypeEnum {
  STAY = 1,
  NIGHT = 2,
}

export class HotelContractType {
  id: HotelContractTypeEnum;
  name?: string;
}

export enum HotelContractTypeEnum {
  NEGOTIATED_RATES = 1,
  ON_REQUEST_RATES = 2,
  NOT_NEGOTIATED = 3,
}

export class HotelContractUpdateCommand {
  idHotelContract: number;
  idHotelContractAgreementFormat: HotelContractAgreementFormatEnum;
  idHotelContractPaymentMode: HotelContractPaymentModeEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
  signedOnDate?: moment.Moment;
  tacitlyRenewedAt?: moment.Moment;
  referentName?: string;
  referentEmail?: string;
  tacitRenewal: boolean;
  cityTax?: number;
  cityTaxNotes?: string;
}

export class HotelCreateCommand {
  idReprotectionAvailabilityState: ReprotectionAvailabilityStateEnum;
  name?: string;
  ianaName?: string;
  hasRestaurant: boolean;
  isChannelManagerActivated: boolean;
  latitude?: number;
  longitude?: number;
  idChannelManager?: number;
  idLanguageCulture?: number;
  idOwner?: number;
  idDealProcessingState: HotelDealProcessingStateEnum;
  idCommercialManagement?: number;
  idHotelChain?: number;
  address?: string;
  rooms?: number;
  roomsPMR?: number;
  hotelCategory?: number;
  sigleRooms?: number;
  doubleRooms?: number;
  tripleRooms?: number;
  quadrupleRooms?: number;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  idChannelManagerProcessingState: ChannelManagerProcessingStateEnum;
  channelManagerProcessingStateUpdatedAt?: moment.Moment;
  externalIdChannelManager?: string;
  notes?: string;
  idsTransportHub?: number[];
}

export class HotelDealProcessingState {
  id: HotelDealProcessingStateEnum;
  name?: string;
  ordinal: number;
}

export enum HotelDealProcessingStateEnum {
  FIRST_CONTACT = 1,
  PROCESSING = 2,
  SOLICIT = 3,
  DEAL_NO_INFO = 4,
  DEAL = 5,
  ONLY_ON_REQUEST = 6,
  NN_ON_REQUEST = 7,
  TEMPORARILY_CLOSED = 8,
  UNINTERESTED = 9,
  OFF_TARGET = 10,
  CLOSED = 11,
  TO_CONTACT = 12,
}

export class HotelExcelExportResponse {
  items?: HotelCompleteListItem[];
}

export class HotelIropContact {
  idHotelIropContact?: number;
  idHotel: number;
  idHotelIropContactType: HotelIropContactTypeEnum;
  isActive: boolean;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  whatsAppPrefix?: string;
  whatsAppPhoneNumber?: string;
  aiCallIsActive: boolean;
}

export class HotelIropContactListResponse {
  items?: HotelIropContact[];
}

export class HotelIropContactSaveCommand {
  idHotel: number;
  hotelIropContacts?: HotelIropContact[];
}

export class HotelIropContactType {
  id: HotelIropContactTypeEnum;
  name?: string;
}

export enum HotelIropContactTypeEnum {
  DAILY_REMIND = 1,
  ON_SERVICE_CREATED = 2,
}

export class HotelListItem {
  idHotel: number;
  transportHubs?: string;
  name?: string;
  idCommercialManagement?: number;
  rooms?: number;
  idDealProcessingState: HotelDealProcessingStateEnum;
  idHotelContractType: HotelContractTypeEnum;
  idHotelContractState: HotelContractStateEnum;
  idOwner?: number;
  representativeEmail?: string;
  updatedAt: moment.Moment;
  roomAvailabilityCommunicationMode: HotelRoomAvailabilityCommunicationMode;
}

export class HotelListResponse {
  items?: HotelListItem[];
  totalRows: number;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
}

export class HotelRoom {
  idHotelRoom?: number;
  idHotelRoomOccupancy: HotelRoomOccupancyEnum;
  idHotelRoomExclusiveService: HotelRoomExclusiveServiceEnum;
  hotelRoomPlanRate: HotelRoomPlanRate;
}

export class HotelRoomAvailabilityCommunicationMode {
  hasChannelManager: boolean;
  hasDailyRemind: boolean;
  hasDailyRemindAi: boolean;
  hasOnServiceCreated: boolean;
  hasOnServiceCreatedAi: boolean;
  notAvailable: boolean;
}

export class HotelRoomExclusiveService {
  id: HotelRoomExclusiveServiceEnum;
  name?: string;
}

export enum HotelRoomExclusiveServiceEnum {
  ROOM_ONLY = 1,
  DAY_USE = 2,
  BED_AND_BREAKFAST = 3,
  NO_SHOW = 4,
}

export class HotelRoomGroup {
  idHotelRoomGroup?: number;
  idHotelRoomType: HotelRoomTypeEnum;
  hotelRooms?: HotelRoom[];
}

export class HotelRoomInformationSource {
  id: HotelRoomInformationSourceEnum;
  name?: string;
}

export enum HotelRoomInformationSourceEnum {
  HOTAC = 1,
  BAKUUN = 2,
  VERTICAL_BOOKING = 3,
  EMAIL = 4,
  REPROTECTION_SURVEY = 5,
  AI_CALL = 6,
}

export class HotelRoomOccupancy {
  id: HotelRoomOccupancyEnum;
  name?: string;
}

export enum HotelRoomOccupancyEnum {
  SINGLE = 1,
  DOUBLE_SINGLE_USE = 2,
  DOUBLE = 3,
  TRIPLE = 4,
  QUADRUPLE = 5,
}

export class HotelRoomPlanRate {
  idHotelRoomPlanRate?: number;
  amount?: number;
  bestAvailableRateSalePercentage?: number;
  noShowPercentage?: number;
}

export class HotelRoomType {
  id: HotelRoomTypeEnum;
  name?: string;
}

export enum HotelRoomTypeEnum {
  STANDARD = 1,
  SUPERIOR = 2,
}

export class HotelUpdateCommand {
  idHotel: number;
  idReprotectionAvailabilityState: ReprotectionAvailabilityStateEnum;
  name?: string;
  ianaName?: string;
  hasRestaurant: boolean;
  isChannelManagerActivated: boolean;
  latitude?: number;
  longitude?: number;
  idLanguageCulture?: number;
  address?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  externalIdChannelManager?: string;
  idChannelManager?: number;
  idCommercialManagement?: number;
  idHotelChain?: number;
  rooms?: number;
  roomsPMR?: number;
  hotelCategory?: number;
  sigleRooms?: number;
  doubleRooms?: number;
  tripleRooms?: number;
  quadrupleRooms?: number;
  notes?: string;
  channelManagerProcessingStateUpdatedAt?: moment.Moment;
  idChannelManagerProcessingState: ChannelManagerProcessingStateEnum;
  idsTransportHub?: number[];
}

export class IanaNameListForDropDownResponse {
  items?: IanaNameSummary[];
}

export class IanaNameSummary {
  idIanaName: number;
  displayName?: string;
}

export class LanguageCulture {
  idLanguageCulture: number;
  languageCultureName?: string;
  countryName?: string;
}

export class LanguageCultureListQueryResponse {
  items?: LanguageCulture[];
}

export class OwnershipCreateCommand {
  idUserOwner: number;
  idHotelDealProcessingState: HotelDealProcessingStateEnum;
  idHotel?: number;
  idCustomer?: number;
  idCommercialManagement?: number;
}

export class OwnershipItem {
  idOwnership: number;
  idUserOwner: number;
  idHotelDealProcessingState: HotelDealProcessingStateEnum;
}

export class OwnershipUpdateCommand {
  idOwnership: number;
  idUserOwner: number;
  idHotelDealProcessingState: HotelDealProcessingStateEnum;
}

export class PassengerGroupListUploadType {
  id: PassengerGroupListUploadTypeEnum;
  name?: string;
}

export enum PassengerGroupListUploadTypeEnum {
  NEOS_COPY_AND_PASTE = 1,
}

export enum PassengerRegistrationTypeEnum {
  WITH_REGISTRATION = 1,
  WITHOUT_REGISTRATION = 2,
  IMPORTED_FROM_LIST = 3,
}

export class Representative {
  idRepresentative: number;
  name?: string;
  idRepresentativeDepartement: RepresentativeDepartementEnum;
  role?: string;
  isMainRepresentative: boolean;
  operativeEmail?: string;
  prefixPhone?: string;
  phoneNumber?: string;
  prefixMobilePhone?: string;
  mobilePhoneNumber?: string;
}

export class RepresentativeCreateCommand {
  idRepresentativeDepartement: RepresentativeDepartementEnum;
  idHotel?: number;
  idCommercialManagement?: number;
  idCustomer?: number;
  name?: string;
  role?: string;
  isMainRepresentative: boolean;
  operativeEmail?: string;
  prefixPhone?: string;
  phoneNumber?: string;
  prefixMobilePhone?: string;
  mobilePhoneNumber?: string;
}

export class RepresentativeDepartement {
  id: RepresentativeDepartementEnum;
  name?: string;
}

export enum RepresentativeDepartementEnum {
  ADMINISTRATION = 1,
  FRONT_OFFICE = 2,
  RESERVATION = 3,
  COMMERCIAL_S_M = 4,
  MANAGEMENT = 5,
  F_B = 6,
  EVENTS_GROUP = 7,
  MICE = 8,
  REVENUE = 9,
  IT = 10,
}

export class RepresentativeListResponse {
  items?: Representative[];
  commercialManagementRepresentative: Representative;
}

export class RepresentativeUpdateCommand {
  idRepresentative: number;
  idRepresentativeDepartement: RepresentativeDepartementEnum;
  idHotel?: number;
  idCommercialManagement?: number;
  idCustomer?: number;
  name?: string;
  role?: string;
  isMainRepresentative: boolean;
  operativeEmail?: string;
  prefixPhone?: string;
  phoneNumber?: string;
  prefixMobilePhone?: string;
  mobilePhoneNumber?: string;
}

export enum ReprotectionAvailabilityStateEnum {
  ACTIVE = 1,
  INACTIVE = 2,
}

export class Result {
  isSuccess: boolean;
  message?: string;
  stacktrace?: string;
  exception: ApplicationException;
}

export class SalesCommunicationActivityAttachment {
  idCommunicationAttachment: number;
  idAttachment: number;
  idCommunication: number;
  attachment: Attachment;
}

export class SalesCommunicationActivityAttachmentDeleteCommand {
  idAttachment: number;
}

export class SalesCommunicationActivityAttachmentListQueryResponse {
  items?: SalesCommunicationActivityAttachment[];
}

export class SalesCommunicationActivityCreateCommand {
  idHotel?: number;
  idCommercialManagement?: number;
  idSalesCommunicationActivityType: SalesCommunicationActivityTypeEnum;
  idSalesCommunicationActivityMethod: SalesCommunicationActivityMethodEnum;
  idSalesCommunicationActivityDirection: SalesCommunicationActivityDirectionEnum;
  emailSubject?: string;
  idUserSenderOrRecipient: number;
  communicationReceivedDate: moment.Moment;
  notes?: string;
  nameUserCreatedBy?: string;
}

export class SalesCommunicationActivityDirection {
  id: SalesCommunicationActivityDirectionEnum;
  name?: string;
}

export enum SalesCommunicationActivityDirectionEnum {
  SENT = 1,
  RECEIVED = 2,
}

export class SalesCommunicationActivityItem {
  idSalesCommunicationActivity: number;
  idSalesCommunicationActivityType: SalesCommunicationActivityTypeEnum;
  idSalesCommunicationActivityMethod: SalesCommunicationActivityMethodEnum;
  idSalesCommunicationActivityDirection: SalesCommunicationActivityDirectionEnum;
  emailSubject?: string;
  idUserSenderOrRecipient?: number;
  communicationReceivedDate: moment.Moment;
  notes?: string;
  nameUserCreatedBy?: string;
  attachmentCount?: number;
  updatedAtUtc: moment.Moment;
}

export class SalesCommunicationActivityListResponse {
  items?: SalesCommunicationActivityItem[];
}

export class SalesCommunicationActivityMethod {
  id: SalesCommunicationActivityMethodEnum;
  name?: string;
}

export enum SalesCommunicationActivityMethodEnum {
  EMAIL = 1,
  PHONE_CALL = 2,
  VIDEO_CALL = 3,
  MEETING = 4,
  BACK_OFFICE = 5,
}

export class SalesCommunicationActivityType {
  id: SalesCommunicationActivityTypeEnum;
  name?: string;
}

export enum SalesCommunicationActivityTypeEnum {
  FIRST_CONTACT = 1,
  REMINDER = 2,
  INFO_REQUEST = 3,
  NEGOTIATION = 4,
  POSITIVE_CLOSURE = 5,
  NEGATIVE_CLOSURE = 6,
  CRM = 7,
  CM_CONNECTIVITY = 8,
  LINK_CONNECTIVITY = 9,
  OTHER = 10,
}

export class SalesCommunicationActivityUpdateCommand {
  idCommunication: number;
  idSalesCommunicationActivityType: SalesCommunicationActivityTypeEnum;
  idSalesCommunicationActivityMethod: SalesCommunicationActivityMethodEnum;
  idSalesCommunicationActivityDirection: SalesCommunicationActivityDirectionEnum;
  emailSubject?: string;
  idUserSenderOrRecipient: number;
  communicationReceivedDate: moment.Moment;
  communicationsSentOrReceived?: boolean;
  notes?: string;
}

export class SalesEnumInitializationQueryResponse {
  channelManagerProcessingStates?: ChannelManagerProcessingState[];
  customerContractPaymentModes?: CustomerContractPaymentMode[];
  customerContractTypes?: CustomerContractType[];
  hotelAiCallModes?: HotelAiCallMode[];
  hotelContractAgreementFormats?: HotelContractAgreementFormat[];
  hotelContractPaymentModes?: HotelContractPaymentMode[];
  hotelContractPerTypes?: HotelContractPerType[];
  hotelContractServiceTypes?: HotelContractServiceType[];
  hotelContractStates?: HotelContractState[];
  hotelContractStayTypes?: HotelContractStayType[];
  hotelContractTypes?: HotelContractType[];
  hotelDealProcessingStates?: HotelDealProcessingState[];
  hotelIropContactTypes?: HotelIropContactType[];
  hotelRoomExclusiveServices?: HotelRoomExclusiveService[];
  hotelRoomInformationSources?: HotelRoomInformationSource[];
  hotelRoomOccupancies?: HotelRoomOccupancy[];
  hotelRoomTypes?: HotelRoomType[];
  representativeDepartements?: RepresentativeDepartement[];
  salesCommunicationActivityDirections?: SalesCommunicationActivityDirection[];
  salesCommunicationActivityMethods?: SalesCommunicationActivityMethod[];
  salesCommunicationActivityTypes?: SalesCommunicationActivityType[];
  supplierContractSupplementTypes?: SupplierContractSupplementType[];
  taxRates?: TaxRate[];
  transportHubTypes?: TransportHubType[];
  transportVehicleTypes?: TransportVehicleType[];
}

export class SupplierContact {
  idSupplierContact: number;
  idSupplier: number;
  name?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  isActive: boolean;
}

export class SupplierContactCreateCommand {
  idSupplier?: number;
  name?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  isActive: boolean;
}

export class SupplierContactListByIdSupplierQueryResponse {
  items?: SupplierContact[];
}

export class SupplierContactUpdateCommand {
  idSupplierContact: number;
  idSupplier: number;
  name?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  isActive: boolean;
}

export class SupplierContractSupplementType {
  id: SupplierContractSupplementTypeEnum;
  name?: string;
}

export enum SupplierContractSupplementTypeEnum {
  NIGHT_SUPPLEMENT = 1,
  FESTIVE_SUPPLEMENT = 2,
}

export class SupplierFoodServiceListUsersQueryResponse {
  items?: User[];
}

export class SupplierTransport {
  idSupplierTransport: number;
  idSupplier: number;
  idLanguageCulture: number;
  name?: string;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  owner?: string;
  notes?: string;
}

export class SupplierTransportContract {
  idSupplierTransportContract: number;
  idSupplierTransport?: number;
  idCustomer: number;
  idContractState: SupplierTransportContractStateEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export class SupplierTransportContractCloneCommand {
  idContractSource: number;
  idCustomer: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export enum SupplierTransportContractDirectionTypeEnum {
  BUY = 1,
  SELL = 2,
}

export class SupplierTransportContractListQueryResponse {
  items?: SupplierTransportContract[];
}

export class SupplierTransportContractPlanRate {
  idSupplierTransportContractPlanRate: number;
  idSupplierTransportContract?: number;
  idCustomerContract?: number;
  transportHubs?: TransportHubInfo[];
}

export class SupplierTransportContractPlanRateCloneCommand {
  idSupplierTransportContractPlanRateSource: number;
  idsTransportHub?: number[];
}

export class SupplierTransportContractPlanRateListQueryResponse {
  items?: SupplierTransportContractPlanRate[];
}

export class SupplierTransportContractPlanRateSaveCommand {
  idSupplierTransportContract: number;
  idsTransportHub?: number[];
  idSupplierTransportContractPlanRate?: number;
}

export class SupplierTransportContractRouteCost {
  idSupplierTransportContractRouteCost: number;
  idSupplierTransportContractPlanRate: number;
  idTransportVehicleType: TransportVehicleTypeEnum;
  transportVehicleTypeName?: string;
  idTaxRate: TaxRateEnum;
  taxRateName?: string;
  kmFrom: number;
  kmTo?: number;
  amount: number;
}

export class SupplierTransportContractRouteCostListQueryResponse {
  items?: SupplierTransportContractRouteCost[];
}

export class SupplierTransportContractRouteCostSaveCommand {
  idSupplierTransportContractPlanRate: number;
  idTransportVehicleType: TransportVehicleTypeEnum;
  idTaxRate: TaxRateEnum;
  kmFrom: number;
  amount: number;
  idSupplierTransportContractRouteCost?: number;
  kmTo?: number;
}

export class SupplierTransportContractSaveCommand {
  idSupplierTransport: number;
  idCustomer: number;
  idSupplierTransportContractDirectionType: SupplierTransportContractDirectionTypeEnum;
  startDate: moment.Moment;
  endDate: moment.Moment;
  idSupplierTransportContract?: number;
}

export enum SupplierTransportContractStateEnum {
  ACTIVE = 1,
  INACTIVE = 2,
  EXPIRED = 3,
}

export class SupplierTransportContractSupplement {
  idSupplierTransportContractSupplement: number;
  idSupplierTransportContractPlanRate: number;
  idSupplierContractSupplementType: SupplierContractSupplementTypeEnum;
  idTaxRate: TaxRateEnum;
  taxRateName?: string;
  startTime?: moment.Moment;
  endTime?: moment.Moment;
  percentage: number;
}

export class SupplierTransportContractSupplementListQueryResponse {
  items?: SupplierTransportContractSupplement[];
}

export class SupplierTransportContractSupplementSaveCommand {
  idSupplierTransportContractSupplement?: number;
  idSupplierTransportContractPlanRate: number;
  idSupplierContractSupplementType: SupplierContractSupplementTypeEnum;
  idTaxRate: TaxRateEnum;
  startTime?: moment.Moment;
  endTime?: moment.Moment;
  percentage: number;
}

export class SupplierTransportListQueryResponse {
  items?: SupplierTransport[];
}

export class SupplierTransportSaveCommand {
  name?: string;
  idLanguageCulture: number;
  email?: string;
  prefix?: string;
  phoneNumber?: string;
  owner?: string;
  idSupplierTransport?: number;
  notes?: string;
}

export class TaxRate {
  id: TaxRateEnum;
  name?: string;
  rate: number;
  ordinal: number;
}

export enum TaxRateEnum {
  TAX_0 = 1,
  TAX_10 = 2,
  TAX_22 = 3,
}

export class TimeZoneItem {
  idTimeZone: number;
  timeZoneName?: string;
  displayName?: string;
  standardName?: string;
  baseUtcOffset?: string;
}

export class TimeZoneListForDropDownResponse {
  items?: TimeZoneSummary[];
}

export class TimeZoneListQuery {

}

export class TimeZoneListQueryResponse {
  items?: TimeZoneItem[];
}

export class TimeZoneSummary {
  idTimeZone: number;
  displayName?: string;
}

export class TransportHub {
  idTransportHub: number;
  name?: string;
  iataCode?: string;
  cityCode?: string;
  cityName?: string;
  countryName?: string;
  countryCode?: string;
  ianaName?: string;
  location: GeolocationPosition;
}

export class TransportHubAlertOrReminderMassiveActivationCommand {
  idTransportHub: number;
  idHotelIropContactTypeEnum: HotelIropContactTypeEnum;
}

export class TransportHubAlertOrReminderMassiveActivationQueryResponse {
  hotelWithContacts: number;
  hotelWithoutContacts: number;
}

export class TransportHubCreateCommand {
  idTransportHubType?: TransportHubTypeEnum;
  iataCode?: string;
  name?: string;
  ianaName?: string;
  cityCode?: string;
  cityName?: string;
  countryCode?: string;
  countryName?: string;
  isInCity: boolean;
  isManaged: boolean;
  extendedName?: string;
  notes?: string;
  latitude?: number;
  longitude?: number;
}

export class TransportHubInfo {
  idTransportHub: number;
  name?: string;
  iataCode?: string;
}

export class TransportHubListForDropDownQueryResponse {
  items?: TransportHubSummaryDto[];
}

export class TransportHubListQueryResponse {
  items?: TransportHub[];
}

export class TransportHubSummaryDto {
  idTransportHub: number;
  iataAndName?: string;
}

export class TransportHubType {
  id: TransportHubTypeEnum;
  name?: string;
}

export enum TransportHubTypeEnum {
  AIRPORT = 1,
  HARBOR = 2,
  TRAIN_STATION = 3,
  OTHER = 99,
}

export class TransportHubUpdateCommand {
  idTransportHub?: number;
  idTransportHubType?: TransportHubTypeEnum;
  iataCode?: string;
  name?: string;
  ianaName?: string;
  cityCode?: string;
  cityName?: string;
  countryCode?: string;
  countryName?: string;
  isInCity: boolean;
  isManaged: boolean;
  extendedName?: string;
  notes?: string;
  latitude?: number;
  longitude?: number;
}

export class TransportVehicleType {
  id: TransportVehicleTypeEnum;
  name?: string;
  capacity: number;
  ordinal: number;
}

export enum TransportVehicleTypeEnum {
  CAR = 1,
  VAN = 2,
  BUS_S = 3,
  BUS_M = 4,
  BUS_L = 5,
}

export class User {
  idUser: number;
  idAuthUser: number;
  idLanguageCulture: number;
  name?: string;
  surname?: string;
  email?: string;
  username?: string;
  prefix?: string;
  phoneNumber?: string;
  lockedDateUtc?: moment.Moment;
  activationDateUtc?: moment.Moment;
  idAuthRole?: number;
  authRoleCode?: string;
  authRoleName?: string;
}

export class UserCreateCommand {
  idLanguageCulture: number;
  idAuthRole: number;
  name?: string;
  surname?: string;
  username?: string;
  prefix?: string;
  phoneNumber?: string;
  idCustomerAirlineCompany?: number;
  idSupplierTransport?: number;
  idSupplierFoodServiceCompany?: number;
}

export class UserListByEntityQueryResponse {
  items?: User[];
}

export class UserListQuery {

}

export class UserListQueryResponse {
  items?: User[];
}

export class UserReadInfoQueryResponse {
  idUser: number;
  idAuthUser: number;
  username?: string;
  name?: string;
  surname?: string;
  authApplicationCode?: string;
  authRoleCode?: string;
  authRoleName?: string;
  language: LanguageCulture;
  customerAirlineCompany: CustomerAirlineCompany;
}

export class UserUpdateCommand {
  idUser: number;
  idAuthRole: number;
  authApplicationCode?: string;
  name?: string;
  surname?: string;
  username?: string;
  prefix?: string;
  phoneNumber?: string;
  idCustomerAirlineCompany?: number;
  idSupplierTransport?: number;
  idSupplierFoodServiceCompany?: number;
}

export enum VoucherSnackManagementTypeEnum {
  VOUCHER = 1,
  VOUCHER_AND_BOARDING_PASS = 2,
  BOARDING_PASS = 3,
}

export class CustomerContractAttachmentCreate {
  file: File;
  id: number;
  messageText: string;
}

export class HotelContractAttachmentCreate {
  file: File;
  id: number;
  messageText: string;
}

export class SalesCommunicationActivityAttachmentCreate {
  file: File;
  id: number;
  messageText: string;
}

  
